module.exports = __webpack_public_path__ + "img/service-6.525a879a.jpg";